import { selectBNInitWaitingMessage } from './../_selectors/bn.selectors';
// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectBNInStore, selectBNPageLoading } from './../_selectors/bn.selectors';

export class BNDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectBNPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectBNInitWaitingMessage)
		);

		this.store.pipe(
			select(selectBNInStore)
		).subscribe((response: QueryResultsModel) => {
            //console.log('The res is',response)
			this.paginatorTotalSubject.next(response.resultCount);
			this.entitySubject.next(response.list);
		});
	}
}
